// extracted by mini-css-extract-plugin
export default {"smalltext":"SolidityScan_smalltext__gxTe7","SSLogo":"SolidityScan_SSLogo__isOwL"};